import { IconAlertTriangle } from '@tabler/icons-react';
import type { ReactNode } from 'react';

interface WarningAlertAction {
  label: string;
  onClick: () => void;
}

interface WarningAlertProps {
  title: string;
  message: string;
  icon?: ReactNode;
  action?: WarningAlertAction;
  className?: string;
}

export function WarningAlert({ title, message, icon, action, className }: WarningAlertProps) {
  return (
    <div className={`alert alert-warning w-100 ${className ?? 'my-3'}`} role="alert">
      <div className="d-flex justify-content-between align-items-center w-100">
        <div className="d-flex align-items-center">
          <div className="me-3">{icon || <IconAlertTriangle size={24} />}</div>
          <div>
            <h4 className="alert-title">{title}</h4>
            <div className="text-secondary">{message}</div>
          </div>
        </div>
        {action && (
          <div className="ms-auto">
            <button type="button" className="btn btn-warning" onClick={action.onClick}>
              {action.label}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
